export const RESET_UNI_NOTICES = 'RESET_UNI_NOTICES'

export interface ResetUniNoticesAction {
  type: typeof RESET_UNI_NOTICES
}

export const resetUniNoticesAction = () => ({ type: RESET_UNI_NOTICES })
